(function () {
  var VIN_FORMAT_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;
  var VIN_ERROR_MESSAGE = 'Enter a valid 17-character VIN. No spaces, symbols, I, O, or Q.';
  var MODE_SELECTOR = 'select[name="properties[VIN or EZ Lynk S/N]"]';

  var VIN_VALUES = {
    A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8,
    J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9,
    S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9
  };

  var VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

  function normalizeVin(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function normalizeSerial(value) {
    return String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function getSelectedInputMode() {
    var selector = document.querySelector(MODE_SELECTOR);
    return selector ? selector.value : 'VIN';
  }

  function getVinCharValue(char) {
    if (/[0-9]/.test(char)) return Number(char);
    return VIN_VALUES[char] || 0;
  }

  function hasValidCheckDigit(vin) {
    var sum = 0;

    for (var i = 0; i < 17; i++) {
      sum += getVinCharValue(vin[i]) * VIN_WEIGHTS[i];
    }

    var remainder = sum % 11;
    var expectedCheckDigit = remainder === 10 ? 'X' : String(remainder);

    return vin[8] === expectedCheckDigit;
  }

  function isValidVin(value) {
    var vin = normalizeVin(value);

    if (!VIN_FORMAT_REGEX.test(vin)) return false;
    if (/^(.)\1{16}$/.test(vin)) return false;

    if (
      vin === '12345678901234567' ||
      vin === '00000000000000000' ||
      vin === '11111111111111111' ||
      vin === '22222222222222222' ||
      vin === '33333333333333333' ||
      vin === '44444444444444444' ||
      vin === '55555555555555555' ||
      vin === '66666666666666666' ||
      vin === '77777777777777777' ||
      vin === '88888888888888888' ||
      vin === '99999999999999999'
    ) {
      return false;
    }

    return hasValidCheckDigit(vin);
  }

  function isVisible(element) {
    if (!element) return false;

    return (
      element.offsetParent !== null &&
      window.getComputedStyle(element).display !== 'none' &&
      window.getComputedStyle(element).visibility !== 'hidden'
    );
  }

  function getVisibleInput(selector, context) {
    context = context || document;

    var inputs = context.querySelectorAll(selector);

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var wrapper = input.closest('.vin-input, .serial-input') || input;

      if (isVisible(input) && isVisible(wrapper)) {
        return input;
      }
    }

    return null;
  }

  function getVinInput(context) {
    return getVisibleInput(
      '.vin-input input, .vin-input textarea, input.vin-input, textarea.vin-input',
      context
    );
  }

  function getSerialInput(context) {
    return getVisibleInput(
      '.serial-input input, .serial-input textarea, input.serial-input, textarea.serial-input',
      context
    );
  }

  function getProductForm(input) {
    if (!input) return null;

    var formId = input.getAttribute('form');
    if (formId) return document.getElementById(formId);

    return input.closest('form');
  }

  function getAddToCartButtons(input) {
    var selectors = [
      'button[type="submit"]',
      'input[type="submit"]',
      'button[name="add"]',
      '.product-form__submit'
    ];

    var form = getProductForm(input);

    if (!form) {
      return document.querySelectorAll(selectors.join(', '));
    }

    var formId = form.getAttribute('id');

    if (!formId) {
      return form.querySelectorAll(selectors.join(', '));
    }

    var scopedSelectors = selectors.map(function (selector) {
      return selector + '[form="' + formId + '"], form#' + formId + ' ' + selector;
    });

    return document.querySelectorAll(scopedSelectors.join(', '));
  }

  function updateAddToCartState(input, isValid) {
    var buttons = getAddToCartButtons(input);

    buttons.forEach(function (button) {
      if (isValid) {
        button.classList.remove('vin-disabled');
        button.removeAttribute('data-vin-locked');
        button.setAttribute('aria-disabled', 'false');
      } else {
        button.classList.add('vin-disabled');
        button.setAttribute('data-vin-locked', 'true');
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function updateVinHelper(input, vin, isValid) {
    var wrapper = input.closest('.vin-input');
    if (!wrapper) return;

    var helper = wrapper.querySelector('.vin-dynamic-help');

    if (!helper) {
      helper = document.createElement('div');
      helper.className = 'vin-dynamic-help';
      wrapper.appendChild(helper);
    }

    helper.classList.remove('is-valid', 'is-invalid');

    if (vin.length === 0) {
      helper.textContent = '';
      return;
    }

    if (vin.length < 17) {
      helper.textContent = 'VIN must be 17 characters';
      helper.classList.add('is-invalid');
      return;
    }

    if (!isValid) {
      helper.textContent = 'Invalid VIN. Check for accuracy and try again.';
      helper.classList.add('is-invalid');
      return;
    }

    helper.textContent = 'Valid VIN';
    helper.classList.add('is-valid');
  }

  function clearVinState(input) {
    if (!input) return;

    input.classList.remove('vin-invalid', 'vin-valid');
    input.setCustomValidity('');

    var wrapper = input.closest('.vin-input');
    var helper = wrapper ? wrapper.querySelector('.vin-dynamic-help') : null;

    if (helper) {
      helper.textContent = '';
      helper.classList.remove('is-valid', 'is-invalid');
    }
  }

  function validateVinLive(input) {
    if (!input) return true;

    var vin = normalizeVin(input.value);
    input.value = vin;

    var isEmpty = vin.length === 0;
    var isValid = isValidVin(vin);

    updateVinHelper(input, vin, isValid);

    input.classList.toggle('vin-invalid', !isEmpty && !isValid);
    input.classList.toggle('vin-valid', !isEmpty && isValid);
    input.setCustomValidity(!isEmpty && !isValid ? VIN_ERROR_MESSAGE : '');

    updateAddToCartState(input, isValid);

    return isValid;
  }

  function validateSerialLive(input) {
    if (!input) {
      updateAddToCartState(null, true);
      return true;
    }

    input.value = normalizeSerial(input.value);
    input.setCustomValidity('');

    updateAddToCartState(input, input.value.length > 0);

    return input.value.length > 0;
  }

  function initValidation() {
    var mode = getSelectedInputMode();
    var vinInput = getVinInput(document);
    var serialInput = getSerialInput(document);

    if (vinInput) {
      vinInput.setAttribute('maxlength', '17');
      vinInput.setAttribute('autocomplete', 'off');
      vinInput.setAttribute('autocapitalize', 'characters');
      vinInput.setAttribute('spellcheck', 'false');
    }

    if (serialInput) {
      serialInput.setAttribute('autocomplete', 'off');
      serialInput.setAttribute('autocapitalize', 'characters');
      serialInput.setAttribute('spellcheck', 'false');
      serialInput.value = normalizeSerial(serialInput.value);
    }

    if (mode === 'Serial Number') {
      if (vinInput) clearVinState(vinInput);
      validateSerialLive(serialInput);
      return;
    }

    if (mode === 'VIN') {
      validateVinLive(vinInput);
      return;
    }

    updateAddToCartState(null, true);
  }

  document.addEventListener('input', function (event) {
    if (!event.target) return;

    if (
      event.target.matches(
        '.vin-input input, .vin-input textarea, input.vin-input, textarea.vin-input'
      )
    ) {
      if (getSelectedInputMode() === 'VIN') {
        validateVinLive(event.target);
      } else {
        clearVinState(event.target);
      }

      return;
    }

    if (
      event.target.matches(
        '.serial-input input, .serial-input textarea, input.serial-input, textarea.serial-input'
      )
    ) {
      validateSerialLive(event.target);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target &&
      event.target.matches(MODE_SELECTOR)
    ) {
      setTimeout(initValidation, 100);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      'button[type="submit"], input[type="submit"], button[name="add"], .product-form__submit'
    );

    if (!button) return;

    var mode = getSelectedInputMode();

    if (mode === 'Serial Number') {
      var serialInput = getSerialInput(document);

      if (!validateSerialLive(serialInput)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (serialInput) serialInput.focus();
        return false;
      }

      return;
    }

    if (mode === 'VIN') {
      var vinInput = getVinInput(document);

      if (!validateVinLive(vinInput)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (vinInput) {
          vinInput.focus();
          vinInput.reportValidity();
        }

        return false;
      }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var mode = getSelectedInputMode();

    if (mode === 'Serial Number') {
      var serialInput = getSerialInput(document);

      if (!validateSerialLive(serialInput)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (serialInput) serialInput.focus();
        return false;
      }

      return;
    }

    if (mode === 'VIN') {
      var vinInput = getVinInput(document);

      if (!validateVinLive(vinInput)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (vinInput) {
          vinInput.focus();
          vinInput.reportValidity();
        }

        return false;
      }
    }
  }, true);

  document.addEventListener('DOMContentLoaded', initValidation);
  document.addEventListener('fieldLoad', initValidation);
  window.addEventListener('load', initValidation);

  setTimeout(initValidation, 500);
  setTimeout(initValidation, 1500);
  setTimeout(initValidation, 2500);
})();